import { useState } from 'react'
import {
  useAmbassadorData,
  type MonthlyReportXlsxExportParams,
} from '../ambassador/useAmbassadorData'
import { buildMonths, downloadBase64Pdf } from './export.utils'
import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'

function useAmbassadorExport(createdAt: string | null) {
  const {
    globalMonthlyReportXlsxExport,
    singleAmbassadorMonthlyReportXlsxExport,
  } = useAmbassadorData()
  const [downloadingKey, setDownloadingKey] = useState<string | null>(null)
  const { setNotification } = useLocalNotifications()

  async function handleExportGlobal({
    month,
    year,
  }: MonthlyReportXlsxExportParams) {
    const key = `${year}-${month}`
    setDownloadingKey(key)
    try {
      const base64 = await globalMonthlyReportXlsxExport.mutateAsync({
        month,
        year,
      })
      downloadBase64Pdf(
        base64,
        `report-${year}-${String(month).padStart(2, '0')}.xlsx`
      )
    } catch {
      setNotification('error', 'Report sa nepodarilo stiahnuť.')
    } finally {
      setDownloadingKey(null)
    }
  }

  async function handleExportSingle(
    month: MonthlyReportXlsxExportParams,
    ambassadorId: string
  ) {
    const key = `${month.year}-${month.month}`
    setDownloadingKey(key)
    try {
      const base64 = await singleAmbassadorMonthlyReportXlsxExport.mutateAsync({
        ambassadorId,
        month: month.month,
        year: month.year,
      })
      downloadBase64Pdf(
        base64,
        `report-${month.year}-${String(month.month).padStart(2, '0')}.xlsx`
      )
    } catch {
      setNotification('error', 'Report sa nepodarilo stiahnuť.')
    } finally {
      setDownloadingKey(null)
    }
  }

  return {
    months: createdAt != null ? buildMonths(createdAt) : [],
    handleExportGlobal,
    handleExportSingle,

    downloadingKey,
  }
}

export { useAmbassadorExport }
